module.exports = __webpack_public_path__ + "static/media/camera.bc2b4524.svg";